export default __webpack_public_path__ + "static/media/StreamingGuide.c8a04ddc.PNG";